import {
  Box,
  Divider,
  SimpleGrid,
  Stack,
  Text,
  Tooltip,
  forwardRef,
} from '@chakra-ui/react';
import { useMemo } from 'react';
import { InlineColorBars } from './ColorBars';
import { CurrencyLabel } from './Currency';
import { WorkOrderSearchRecord } from 'api/bindings/WorkOrderSearchRecord';
import { WorkOrderResponse } from 'api/bindings/WorkOrderResponse';

export interface WorkOrderBarsProps {
  workOrder: WorkOrderSearchRecord | WorkOrderResponse | undefined;
}

const woColors = [
  'pink.500',
  //   'blue.500',
  'yellow.200',
  //   'green.500',
  //   'teal.500',
];
export const WorkOrderBars = forwardRef((props: WorkOrderBarsProps, ref) => {
  const { workOrder, ...other } = props;
  const data = useMemo(() => {
    const invoiced = parseFloat(workOrder?.invoiced || '0');
    const commited = parseFloat(workOrder?.total || '0');
    const pending = parseFloat(workOrder?.pending || '0');
    const budget = parseFloat(workOrder?.totalBudget || '0');
    const contingency = parseFloat(workOrder?.totalContingency || '0');

    return {
      invoiced,
      commited,
      pending,
      budget,
      contingency,
      availableToInvoice: commited - invoiced,
      availableToCommit: budget - commited,
    };
  }, [workOrder]);

  const Overlay = () => (
    <Box p={4}>
      <Stack>
        <SimpleGrid columns={2} spacing={2}>
          <Text as="b">Total:</Text>
          <CurrencyLabel value={data.commited} />
          <Text as="b">Pending:</Text>
          <CurrencyLabel value={data.pending} />
          <Text as="b">Invoiced:</Text>
          <CurrencyLabel value={data.invoiced} />
          <Text as="b">Budget:</Text>
          <CurrencyLabel value={data.budget} />
          <Text as="b">Contingency:</Text>
          <CurrencyLabel value={data.contingency} />
        </SimpleGrid>
        <Divider />
        <SimpleGrid columns={2} spacing={2}>
          <Text as="b">Commitable:</Text>
          <CurrencyLabel value={data.availableToCommit} />
          <Text as="b">Invoiceable:</Text>
          <CurrencyLabel value={data.availableToInvoice} />
        </SimpleGrid>
      </Stack>
    </Box>
  );
  return (
    <Tooltip label={<Overlay />}>
      <InlineColorBars
        colors={woColors}
        values={[
          //   data.invoiced,
          data.commited,
          data.pending,
          //   data.pending,
          //   data.budget + data.contingency,
          //   data.contingency,
        ]}
        {...other}
        ref={ref}
      />
    </Tooltip>
  );
});
